
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch
} from "vue";
import {Request} from "@/api/request";
import {useRoute} from "vue-router";
const columnList: Array<any> = [
    {
        prop: "category",
        label: "类别",
        width: 200,
    },
    {
        prop: "project_name",
        label: "检车项",
        width: 100,
    }
]
export default {
    name: "carcheckproject",
    setup(){
        const setTitle: any = inject("setTitle");
        setTitle(["检车项目"]);
        let tableData = ref([]),
            loading = ref(true),
            headClass = inject("headClass"),
            pageSize = ref(10),
            total = ref(0),
            currentPage = ref(1);
        let getTableData = (): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Carcheck/carProjectList',
                    data: {page:currentPage.value,pagesize:pageSize.value}
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    total.value = res?.content.total;
                    loading.value = false;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            _upState = (id:number)=>{
                Request.axiosInstance({
                    url:　'adminapi/Carcheck/upState',
                    data: {id}
                }).then((res: any) => {
                    res.status == 202 && getTableData()
                });
            };
        onMounted(() => {
            getTableData()
        });
        return{
            columnList,
            tableData,
            loading,
            headClass,
            pageSize,
            currentPage,
            getTableData,
            _upState,
            handleSizeChange,
            handleCurrentChange,
            total
        }
    }
}
